import { useCallback, useEffect } from 'react';
import {
  setDeleteErrorDialogOpen,
  setDeleteMessage,
  setDeleteSuccessDialogOpen,
} from 'redux/reducers/meteorologyAgroGroupLocationFeedbackReducer';
import { store } from 'redux/store';
import { ResponseError } from 'services/api/base';
import { useDeleteAgroLocationMutation } from 'services/api/Meteorology/Agro';

export default function useDeleteLocation() {
  const [trigger, { data, isLoading, error }] = useDeleteAgroLocationMutation();
  const deleteLocation = useCallback((id: number) => {
    trigger({ id });
  }, [trigger]);

  useEffect(() => {
    if (data) {
      const successMessage = data.message || 'Local excluído com sucesso.';
      store.dispatch(setDeleteMessage(successMessage));
      store.dispatch(setDeleteSuccessDialogOpen(true));
    }
  }, [data]);

  useEffect(() => {
    if (error) {
      const errorMessage = (error as ResponseError).description || 'Erro ao excluir o local.';
      store.dispatch(setDeleteMessage(errorMessage));
      store.dispatch(setDeleteErrorDialogOpen(true));
    }
  }, [error]);

  return {
    deleteLocation,
    isDeletingLocation: isLoading,
  };
}
